export default "__VITE_ASSET__a9c2684e__"